import { Dropdown, Space } from 'antd';
import { useSelector } from 'react-redux';
import { DownOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { CustomMainContent, DropDownFilterDates } from '../../../components';
import { CardBarRadar } from '../../../components/common/NewUi/CardBarRadar';
import { CardBarChar } from '../../../components/common/NewUi/CardBarChar';
import CardProgress from '../../../components/common/NewUi/CardProgress';
import CardNumber from '../../../components/common/NewUi/CardNumber';
import Meanings from '../../../components/common/NewUi/Meanings';
import Ranking from '../../../components/common/NewUi/Ranking';
import { onGetAllAlumsByGroups } from '../../../api';
import { gifs } from '../../../assets/gifs';
import { CardBarCharCemex } from '../../../components/common/NewUi/CardBarCharCemex';

const statusTypes = {
    active: 'active',
    finished: 'finished',
}

const now = new Date();


export const LearningDashboardCemex = () => {

    // NEW
    const [usersInfo, setusersInfo] = useState([])
    const [groupList, setGroupList] = useState([])
    const [Loader, setLoader] = useState(true)
    const allUserResponses = useRef([]);
    const [groupSelected, setGroupSelected] = useState("TODOS");
    const [textBefore, settextBefore] = useState("Respecto al año anterior")
    const [groupInformation, setgroupInformation] = useState(null);
    const [modulesInformation, setmodulesInformation] = useState(null);
    const [countNew, setCountNew] = useState({ total: 0, active: 0, inactive: 0, finished: 0 });
    const [dateRange, setDataRange] = useState({ start: new Date(now.getFullYear(), 0, 1, 0, 0, 0), end: new Date(now.getFullYear(), 11, 31, 23, 59, 59) });
    const lastDateRange = useRef({ startDate: new Date(now.getFullYear() - 1, 0, 1, 0, 0, 0), endDate: new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59) })

    // OLD
    const [usersByGroups, setusersByGroups] = useState([]);
    const { arrayData } = useSelector(state => state.table);
    const { groups } = useSelector((state) => state.vrlSlice);
    const { responses } = useSelector(state => state.vrlSlice);
    const [totalUsersParticipate, setTotalUsersParticipate] = useState(0)



    const getInformationV2 = (responses = []) => {
        return responses.reduce((result, { responses, group, durationInSeconds, studentId, student }) => {
            if (!responses) return result;
            const moduleNames = Object.keys(responses);
            const timePerModule = durationInSeconds / moduleNames.length;

            moduleNames.forEach(key => {
                const { answer } = responses[key];
                const isCorrect = answer === "True" ? 1 : 0;
                const isIncorrect = answer !== "True" ? 1 : 0;
                if (!result.peopleInformation.has(studentId)) {
                    result.peopleInformation.set(studentId, {})
                }

                const studentData = result.peopleInformation.get(studentId);
                if (!studentData[key]) {
                    studentData[key] = { corrects: 0, incorrects: 0, time: 0, student };
                }
                studentData[key].corrects += isCorrect
                studentData[key].incorrects += isIncorrect
                studentData[key].time += timePerModule;

                const { name: groupName } = group;
                if (!result.groupInformation.has(groupName)) {
                    result.groupInformation.set(groupName, {});
                }

                const groupData = result.groupInformation.get(groupName);
                if (!groupData[key]) {
                    groupData[key] = { corrects: 0, incorrects: 0 };
                }
                groupData[key].corrects += isCorrect
                groupData[key].incorrects += isIncorrect

                if (!result.modulesInformation.has(key)) {
                    result.modulesInformation.set(key, { name: key, corrects: 0, incorrects: 0, time: 0 })
                }
                const moduleData = result.modulesInformation.get(key);
                moduleData.corrects += isCorrect;
                moduleData.incorrects += isIncorrect;
                moduleData.time += timePerModule;
            });
            setLoader(false)
            return result
        }, {
            modulesInformation: new Map(),
            groupInformation: new Map(),
            peopleInformation: new Map()
        })


    }

    /**
     * Fetches and processes user data based on filtered responses and selected group.
     * 
     * @function
     * @param {Object} params - The parameters object.
     * @param {Array} params.filteredDataResponses - Array of filtered data responses.
     * @param {Object} params.groupSelected - The selected group.
     * 
     * @returns {Promise<void>} - A promise that resolves when the user data has been processed and set.
     * 
     * @example
     * getUsers({ filteredDataResponses: [], groupSelected: {} });
     * 
     * @async
     */
    const getUsers = useCallback(async ({ filteredDataResponses = [], groupSelected, isForAll }) => {

        // TODO: aqui cambiar la cantidad de usuarios que se compara para la fecha verde 
        let users = 0
        const grups = await onGetAllAlumsByGroups(groups)
        grups.forEach(grup => {

            if (groupSelected === grup.group || groupSelected === "TODOS") {
                users += grup.students.length
            }
        })
        setusersByGroups(users)
        // TODO


        const dataStandarSeconds = filteredDataResponses.map(element => {
            let updatedElement = { ...element }; // Copia del objeto
            if (updatedElement.responses) {
                let tieneM1 = Object.keys(updatedElement.responses).some(key => key.includes("M1"));
                if (tieneM1) {
                    updatedElement.durationInSeconds = Math.min(updatedElement.durationInSeconds, 10);
                } else {
                    updatedElement.durationInSeconds = Math.min(updatedElement.durationInSeconds, 60);
                }
            }

            return updatedElement;
        });
        const { groupInformation, modulesInformation, } = getInformationV2(dataStandarSeconds);
        const formatedResponses = new Map();

        for (const element of dataStandarSeconds) {
        // let timeSecondsEstable = 0
        // if (element.responses && Object.keys(element.responses).some(key => key.includes("M1"))) {
        //     if (element.durationInSeconds > 10) {
        //         timeSecondsEstable = 10;
        //     }
        //     else {
        //         timeSecondsEstable = element.durationInSeconds;
        //     }
        // }
        // else {
        //     if (element.durationInSeconds > 60) {
        //         timeSecondsEstable = 60;
        //     }
        //     else {
        //         timeSecondsEstable = element.durationInSeconds;
        //     }
        // }

            const { responses, student, durationInSeconds } = element;
            if (!responses) continue;
            if (!formatedResponses.has(student.userId)) {
                formatedResponses.set(student.userId, {
                    userId: element.student.userId,
                    date: element.createdAt,
                    name: element.student.name,
                    responses: [],
                    group: element.group,
                    time: 0,
                    status: statusTypes.active,
                })
            }
            const user = formatedResponses.get(student.userId);
            user.time += durationInSeconds;
            user.responses.push(...Object.values(responses))
            if (user.status !== statusTypes.finished) {
                const finalQuestion = responses["M4_L5"];
                user.status = finalQuestion && finalQuestion.answer === "True" ? statusTypes.finished : statusTypes.active;
            }
        }

        // Sort para ordenar raning de desempe;o
        const usersInformation = Array.from(formatedResponses, ([_, value]) => ({ ...value }));

        if (isForAll) {
            allUserResponses.current = usersInformation;
            // console.log('for all')
            // console.log(allUserResponses.current, usersInformation.length)

        }
        let filterUsers = usersInformation.sort((a, b) => {
            const isFinishedA = a.status === "finished";
            const isFinishedB = b.status === "finished";

            const allCorrectA = a.responses.every(r => r.answer === "True" && r.correctAnswer === "True");
            const allCorrectB = b.responses.every(r => r.answer === "True" && r.correctAnswer === "True");

            const hasM1L1A = a.responses.some(r => r.question === "M1_L1" && r.answer === "True");
            const hasM1L1B = b.responses.some(r => r.question === "M1_L1" && r.answer === "True");

            const hasM4L5A = a.responses.some(r => r.question === "M4_L5" && r.answer === "True");
            const hasM4L5B = b.responses.some(r => r.question === "M4_L5" && r.answer === "True");

            const incorrectA = a.responses.filter(r => r.answer !== r.correctAnswer).length;
            const incorrectB = b.responses.filter(r => r.answer !== r.correctAnswer).length;

            // Prioridad 1 "finished" primero
            if (isFinishedA && !isFinishedB) return -1;
            if (isFinishedB && !isFinishedA) return 1;

            // Prioridad 2 Todos correctos y cumplen M1_L1 y M4_L5
            if (allCorrectA && hasM1L1A && hasM4L5A && !(allCorrectB && hasM1L1B && hasM4L5B)) return -1;
            if (allCorrectB && hasM1L1B && hasM4L5B && !(allCorrectA && hasM1L1A && hasM4L5A)) return 1;

            // Prioridad 3 Menos respuestas incorrectas
            if (incorrectA !== incorrectB) return incorrectA - incorrectB;

            // Prioridad 4 Menor tiempo
            return a.time - b.time;
        });
        setusersInfo(filterUsers)
        setTotalUsersParticipate(filterUsers.reduce((count, obj) => count + (obj.status === statusTypes.finished), 0))
        // console.log(modulesInformation)
        setmodulesInformation(modulesInformation)
        console.log(modulesInformation)
        setgroupInformation(groupInformation)




    }, [groups])




    useEffect(() => {
        getUsers({ filteredDataResponses: responses })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayData, groups])

    const getAverage = (keys, dat, name = "incorrects") => {
        if (!dat || dat.size <= 0) {
            return 0
        }
        let sum = 0
        keys.forEach(key => {
            sum += dat.get(key)?.[name]
        })
        return Math.round(sum / totalUsersParticipate)
    }

    const getAveragePonts = (keys, dat, max) => {
        if (!dat || dat.size <= 0) {
            return 0
        }
        let sumcorrects = 0
        let sumincorrects = 0
        keys.forEach(key => {
            sumcorrects += dat.get(key)?.corrects
            sumincorrects += dat.get(key)?.incorrects
        })
        return Math.round(max * ((sumcorrects * 100) / (sumcorrects + sumincorrects) / 100))
    }

    const filterResponses = useCallback(({ dateRange, groupSelected }) => {
        const groupList = new Set();
        const { start, end } = dateRange;
        const endFormated = new Date(end);
        const startFormated = new Date(start);
        const groupName = String(groupSelected).toUpperCase();

        const filteredResponses = responses.filter(({ createdAt: createdAtItem, group }) => {
            const createdAt = new Date(createdAtItem);
            const name = String(group.name).toUpperCase();
            groupList.add(name);

            if (createdAt < startFormated || endFormated < createdAt) return false;
            if (groupName === 'TODOS' || !groupSelected) return true;

            return name === groupName
        });
        groupList.add('TODOS');

        return { filteredResponses, groupList }
    }, [responses])


    useEffect(() => {
        const { filteredResponses, groupList } = filterResponses({ dateRange, groupSelected });

        setGroupList(Array.from(groupList))
        getUsers({ filteredDataResponses: filteredResponses, groupSelected, })

    }, [dateRange, filterResponses, getUsers, groupSelected]);



    useEffect(() => {
        getUsers({ filteredDataResponses: responses, groupSelected, isForAll: true })
    }, [getUsers, groupSelected, responses]);
    useEffect(() => {

        const counter = { total: 0, active: 0, inactive: 0, finished: 0 }
        const actualCounter = { total: 0, active: 0, inactive: 0, finished: 0 }
        const { endDate, startDate } = lastDateRange.current;
        const actualEnd = dateRange.end.getTime();
        const actualStart = dateRange.start.getTime();

        for (let index = 0; index < allUserResponses.current.length; index++) {
            const { date, status, responses } = allUserResponses.current[index];
            const dateCreated = new Date(date).getTime();


            if (dateCreated >= startDate && endDate > dateCreated) {
                counter.total += 1;
                counter.active += status === statusTypes.active ? 1 : 0;
                counter.finished += status === statusTypes.finished ? 1 : 0;
                counter.inactive += responses.length === 0 ? 1 : 0
            }
            if (dateCreated >= actualStart && actualEnd > dateCreated) {
                actualCounter.total += 1;
                actualCounter.active += status === statusTypes.active ? 1 : 0;
                actualCounter.finished += status === statusTypes.finished ? 1 : 0;
                actualCounter.inactive += responses.length === 0 ? 1 : 0
            }
        }

        setCountNew({
            active: counter.active - actualCounter.active,
            finished: counter.finished - actualCounter.finished,
            inactive: counter.inactive - actualCounter.inactive,
            total: counter.total - actualCounter.total,
            anteriorTotal: counter.total,
            anteriorActive: counter.active,
            anteriorInactive: counter.inactive,
            anteriorFinished: counter.finished,
        })
    }, [dateRange, responses]);






    if (Loader) {
        return <>
            <div style={{ background: "rgba(27, 20, 100, 0.1)" }} className="w-screen h-screen  flex justify-center items-center flex-col">
                <img src={gifs.inmersys_rotate} className="w-36 animate-spin" alt="" />
                {/* <p className="text-2xl text-white font-semibold pt-4 tracking-widest">YOU ARE IN</p> */}
            </div>
        </>
    }
    return (
        <div style={{ background: "rgba(27, 20, 100, 0.1)" }} className='w-full h-screen overflow-scroll'>
            <CustomMainContent>
                <div className="flex w-full min-w-[450px] h-full pr-4">
                    <div className="w-full ">
                        <div className="flex py-3 gap-x-4 pr-6 items-center justify-between">
                            <p className="text-[#686868] text-sm font-semibold font-inter">Usuarios y avance</p>
                            <section className='flex gap-4 text-black'>
                                <DropDownFilterDates
                                    callBack={(start, end, _, { startDate, endDate }, beforeText) => {
                                        settextBefore(beforeText)
                                        lastDateRange.current.startDate = startDate
                                        lastDateRange.current.endDate = endDate
                                        setDataRange({ start, end })
                                    }}
                                />
                                <Dropdown
                                    className='cursor-pointer'
                                    menu={{
                                        items: groupList.map(group => ({ key: group, label: group })),
                                        onClick: ({ key }) => setGroupSelected(key)

                                    }}
                                >
                                    <Space>
                                        <p className="text-black "> {groupSelected}</p>
                                        <DownOutlined />
                                    </Space>
                                </Dropdown>
                            </section>
                        </div>
                        <div className="flex gap-x-4 overflow-x-auto pb-2 ">
                            <CardNumber textBefore={textBefore} anterior={countNew.anteriorTotal} newUsers={countNew.total} title={"Total de usuarios"} value={usersByGroups} color="text-[#282828]" />
                            <CardNumber textBefore={textBefore} anterior={countNew.anteriorActive} newUsers={countNew.active} title={"Usuarios activos"} value={usersInfo.reduce((count, obj) => count + (obj.status === statusTypes.active), 0)} color="text-[#55AE70]" />
                            <CardNumber textBefore={textBefore} anterior={countNew.anteriorInactive} newUsers={countNew.inactive} title={"Usuarios inactivos"} value={usersByGroups - usersInfo.length} color="text-[#AE5555]" />
                            <CardNumber textBefore={textBefore} anterior={countNew.anteriorFinished} newUsers={countNew.finished} title={"Cursos terminados"} value={usersInfo.reduce((count, obj) => count + (obj.status === statusTypes.finished), 0)} color="text-[#282828]" />
                        </div>
                        <div className="flex py-3 gap-x-4 items-center">
                            <p className="text-[#686868] text-sm font-semibold">Promedio General y por Módulo</p>
                        </div>
                        <div className="flex  gap-x-4  overflow-y-auto pb-2">
                            <CardProgress module={"Curso total"} newUsers={100} title={"Puntaje promedio"}
                                value={getAveragePonts(["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6",
                                    "M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5",
                                    "M3_L1", "M3_L2", "M3_L3", "M3_L4",
                                    "M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"], modulesInformation, 100)}
                                maxValue={100} color="text-[#282828]"
                                time={getAverage(["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6",
                                    "M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5",
                                    "M3_L1", "M3_L2", "M3_L3", "M3_L4",
                                    "M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"], modulesInformation, "time")}
                                repetitions={getAverage(["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6",
                                    "M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5",
                                    "M3_L1", "M3_L2", "M3_L3", "M3_L4",
                                    "M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"], modulesInformation, "incorrects")}>
                            </CardProgress>
                            <CardProgress module={"Módulo I"} newUsers={100} title={"Puntaje promedio"}
                                value={getAveragePonts(["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6"], modulesInformation, 30)}
                                maxValue={30} color="text-[#282828]"
                                time={getAverage(["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6"], modulesInformation, "time")}
                                repetitions={getAverage(["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6"], modulesInformation, "incorrects")}>
                            </CardProgress>
                            <CardProgress module={"Módulo II"} newUsers={100} title={"Puntaje promedio"}
                                value={getAveragePonts(["M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5"], modulesInformation, 25)}
                                maxValue={25} color="text-[#282828]"
                                time={getAverage(["M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5"], modulesInformation, "time")}
                                repetitions={getAverage(["M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5"], modulesInformation, "incorrects")}>
                            </CardProgress>
                            <CardProgress module={"Módulo III"} newUsers={100} title={"Puntaje promedio"}
                                value={getAveragePonts(["M3_L1", "M3_L2", "M3_L3", "M3_L4"], modulesInformation, 20)}
                                maxValue={20} color="text-[#282828]"
                                time={getAverage(["M3_L1", "M3_L2", "M3_L3", "M3_L4"], modulesInformation, "time")}
                                repetitions={getAverage(["M3_L1", "M3_L2", "M3_L3", "M3_L4"], modulesInformation, "incorrects")}>
                            </CardProgress>
                            <CardProgress module={"Módulo IV"} newUsers={100} title={"Puntaje promedio"}
                                value={getAveragePonts(["M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"], modulesInformation, 25)}
                                maxValue={25} color="text-[#282828]"
                                time={getAverage(["M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"], modulesInformation, "time")}
                                repetitions={getAverage(["M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"], modulesInformation, "incorrects")}>
                            </CardProgress>
                        </div>
                        <div className="flex py-3 gap-x-4 items-center">
                            <p className="text-[#686868] text-sm font-semibold">Datos analíticos</p>
                        </div>
                        <div className="flex gap-x-4 overflow-x-auto overflow-y-hidden">
                            <Meanings />
                            <CardBarCharCemex usersEnd={usersInfo.reduce((count, obj) => count + (obj.status === statusTypes.finished), 0)} title={"Tiempo promedio por tarea"} info={modulesInformation} ></CardBarCharCemex>
                            <CardBarCharCemex type={"unique"} title={"Número promedio de errores por tarea"} info={modulesInformation} ></CardBarCharCemex>
                        </div>
                        <div className="py-6 flex gap-x-4">
                            <Ranking users={usersInfo} />
                            <CardBarRadar info={groupInformation}></CardBarRadar>
                        </div>
                    </div>
                </div>
            </CustomMainContent>
        </div>
    )
}